import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const BigNewsCard = ({ imageUrl, category, date, title, description, detailsLink }) => {
    // Assuming detailsLink is something like '/news/some-news-slug'
    const slug = detailsLink.split('/').pop();

    return (
        <div className="d-flex justify-content-between card shadow-sm border-light d-none d-xl-block" >
            <img src={imageUrl} className="card-img-top rounded-0" alt="" style={{ height: '360px', objectFit: 'cover' }} />
            <div className="card-body d-flex flex-column p-4 justify-content-end" >
                <div className="d-flex align-items-center">
                    <div className="bg-success-subtle rounded px-2 py-1">
                        <div className="text-success fw-normal small">{category}</div>
                    </div>
                    <div className="d-flex align-items-center px-2">
                        <div className="text-secondary small">{date}</div>
                    </div>
                </div>
                <div className="d-flex flex-column mb-0">
                    <h5 className="card-title fw-medium" style={{ fontSize: '36px' }}>
                        {title}
                    </h5>
                    <p className="card-text mb-0 text-secondary truncated-paragraph">{description}</p>
                </div>
                <Link to={`/news/${slug}`} className="bg-primary gap-5 px-3 py-2 round-0 text-white text-decoration-none round-0 fw-normal small w-100">Read More</Link>
            </div>
        </div>
    );
};

export default BigNewsCard;